import { render, staticRenderFns } from "./lashin-detail.vue?vue&type=template&id=dd75d40e&scoped=true&"
import script from "./lashin-detail.vue?vue&type=script&lang=js&"
export * from "./lashin-detail.vue?vue&type=script&lang=js&"
import style0 from "./lashin-detail.vue?vue&type=style&index=0&id=dd75d40e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd75d40e",
  null
  
)

export default component.exports